export function convertSolToLamports(solInput) {
  const BigIntValue = window.BigInt;
  const normalizedInput = String(solInput ?? '').trim();

  if (!normalizedInput) {
    throw new Error('Enter a SOL amount.');
  }

  if (!/^\d+(\.\d{0,9})?$/.test(normalizedInput)) {
    throw new Error('Enter a valid SOL amount with up to 9 decimals.');
  }

  const [wholePart, fractionalPart = ''] = normalizedInput.split('.');
  const wholeLamports = BigIntValue(wholePart || '0') * 1000000000n;
  const fractionalLamports = BigIntValue(fractionalPart.padEnd(9, '0') || '0');
  const lamports = wholeLamports + fractionalLamports;

  if (lamports <= 0n) {
    throw new Error('Buy amount must be greater than zero.');
  }

  return lamports;
}

export function convertDisplayTokenAmountToAtomic(displayAmount, decimals) {
  const BigIntValue = window.BigInt;
  const normalizedInput = String(displayAmount ?? '')
    .trim()
    .replace(/,/g, '');
  const normalizedDecimals = Number.parseInt(decimals ?? 0, 10);

  if (!normalizedInput) {
    throw new Error('Enter a token amount.');
  }

  if (!Number.isFinite(normalizedDecimals) || normalizedDecimals < 0) {
    throw new Error('Invalid token decimals.');
  }

  const decimalPattern =
    normalizedDecimals === 0
      ? /^\d+$/
      : new RegExp(`^\\d+(\\.\\d{0,${normalizedDecimals}})?$`);

  if (!decimalPattern.test(normalizedInput)) {
    throw new Error(`Enter a valid token amount with up to ${normalizedDecimals} decimals.`);
  }

  const [wholePart, fractionalPart = ''] = normalizedInput.split('.');
  let scale = 1n;

  for (let index = 0; index < normalizedDecimals; index += 1) {
    scale *= 10n;
  }

  const wholeAmount = BigIntValue(wholePart || '0') * scale;
  const fractionalAmount = BigIntValue(fractionalPart.padEnd(normalizedDecimals, '0') || '0');
  const atomicAmount = wholeAmount + fractionalAmount;

  if (atomicAmount <= 0n) {
    throw new Error('Sell amount must be greater than zero.');
  }

  return atomicAmount;
}
